exports.bugsnagApiKey = '59322a1ea1c96206a359ca7781380db4'
exports.onError = (event) => {
    let Sentry

    if (typeof window !== 'undefined' && window.Sentry) {
        Sentry = window.Sentry

        // Temporary - While we are sending errors to both Bugsnag and Sentry,
        // Bugsnag handles the error so we must manually send it to Sentry.
        if (Sentry && Sentry.isInitialized()) {
            Sentry.captureException(event)
        }
    }

    //Testing for our custom keys; this can be expanded.
    if (
        event.originalError &&
        event.originalError.hasOwnProperty('askNicelyMetadata')
    ) {
        event.addMetadata('askNicelyMetadata', {
            askNicelyMetadata: event.originalError.askNicelyMetadata,
        })
    }
}
